export const fadeLeft = { 'data-aos': 'fade-left' }

export function fadeLeftDelay(delay = 300) { return { 'data-aos-delay': delay, ...fadeLeft } }

export function fadeLeftDelayIndex(i = 0, step = 300) { return { 'data-aos-delay': i * step, ...fadeLeft } }